<template>
    <div class="inbox-container">
        <h4>لیست درخواست‌های مشاوره</h4>

        <!-- MESSAGES LIST -->
        <div class="table-container" v-if="response.length">
            <table class="table table-hover">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">شماره تماس</th>
                    <th scope="col">وضعیت مشاوره</th>
                    <th scope="col">نوع مشاوره</th>
                    <th scope="col">تاریخ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in response" :key="index">
                        <th class="index" scope="row">{{ index + 1}}</th>
                        <td>{{ item.Phone }}</td>
                        
                        <td v-if="item.State == 'check'">در حال بررسی</td>
                        <td v-else-if="item.State == 'done'">انجام شده</td>
                        <td v-else-if="item.State == 'failed'">لغو شده</td>
                        <td v-else>-</td>

                        <td v-if="item.Type == 'VideoOnline'">مشاوره ویدیویی (آنلاین)</td>
                        <td v-else-if="item.Type == 'WritingOnline'">مشاوره کتبی (آنلاین)</td>
                        <td v-else-if="item.Type == 'Telephonic'">مشاوره تلفنی</td>
                        <td v-else-if="item.Type == 'Attendance'">مشاوره حضوری</td>
                        <td v-else>-</td>                        
                        
                        <td>{{ item.Created_at | moment }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- EMPTY INBOX -->
        <div class="empty-container" v-else-if="!response.length">
            <h4>موردی یافت نگردید</h4>
        </div>
    </div>
</template>

<script>
import { getRequest } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

import moment from 'moment-jalaali';

export default {
    name: 'MyRequests',
    data() {
        return {
            // list of our cases
            response: [],
        };
    },
    mounted() {
        this.GetAll();
    },
    filters: {
        // will show the date like 'Jun 24th 2020'
        moment: (date) => {
            return moment(date).format('jDD/jMMMM/jYYYY');
        }
    },
    methods: {
        // get list of all advice requests
        GetAll() {
            getRequest('/advice-requests/find-users-all')
                .then(rsp => {
                    // response
                    let data = rsp.data;

                    this.response = data.filter(item => item.State == 'check');
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
    }
}
</script>

<style scoped>
/* --------------------------------- */
/* ------------ GENERAL ------------ */
/* --------------------------------- */
.inbox-container {
    padding: 15pt 10pt;
}
.inbox-container h4 {
    margin-bottom: 1.25rem;
}

/* --------------------------------- */
/* -------- TABLE CONTAINER -------- */
/* --------------------------------- */
.inbox-container table {
    margin-top: 0;
    margin-bottom: 0;

    overflow: scroll;
    min-width: 600pt;
}
.inbox-container table td,
.inbox-container table th {
    vertical-align: middle;
}
.inbox-container .table-container {
    overflow: scroll;
    border: 1pt solid #ccc;
    max-height: calc(100vh - 65pt);
}
.inbox-container .table-container .index {
    width: 35pt;
}
.inbox-container .table-container .options {
    width: 100pt;
}
.inbox-container .table-container .options span {
    font-weight: 500;
}
.inbox-container .table-container .options span:hover {
    cursor: pointer;
    text-decoration: underline;
}

/* --------------------------------- */
/* -------- EMPTY CONTAINER -------- */
/* --------------------------------- */
.empty-container {
    margin: 0 5pt;
    padding: 15pt 25pt;
    
    border: 1pt solid #ccc;
    border-radius: 5pt;
    box-shadow: 2pt 2pt 5pt 0pt #efefef;
    background-color: #efefef;
}
</style>
